import {
	DEFAULT_AUTOTRACK,
	DEFAULT_FLUSH_INTERVAL_MS,
	DEFAULT_PRIVACY,
} from '@l3ns/shared/constants';
import type {
	AutoTrackConfig,
	BridgeRule,
	FormConfig,
	IdentityConfig,
	MappingRule,
	PrivacyConfig,
	WireEvent,
	WireNetRequest,
	WireSession,
} from '@l3ns/shared/types';

export const VERSION = '0.1.0';

/** Keys here are the public diag() output — never mangled. */
export interface Diag {
	/** modules may merge extra numeric counters (e.g. formsScans/formsScanMs) */
	[extra: string]: number;
	initMs: number;
	flushes: number;
	sent: number;
	dropped: number;
	/** Main-thread time spent in the most recent flush() call. */
	lastFlushMs: number;
}

/**
 * Internal state. Field names end in `_` so terser property mangling
 * (regex /_$/) can shorten them in dist; the CONTENTS of auto_/privacy_/
 * session_/q_ keep their real names — they are remote-config/wire shapes.
 */
export interface SdkState {
	key_: string;
	api_: string;
	env_: string;
	rel_: string;
	debug_: boolean;
	consent_: boolean;
	inited_: boolean;
	/** Remote config has settled (arrived, failed, or was declined). */
	cfg_: boolean;
	auto_: AutoTrackConfig;
	privacy_: PrivacyConfig;
	mappings_: MappingRule[];
	formSteps_: FormConfig[];
	zones_: Array<{ key: string; selector: string; urlPattern?: string }>;
	/** Event bridges (third-party emitters re-emitted as events), remote config. */
	bridges_: BridgeRule[];
	/** How the signed-in user is learned (dashboard "User identity"), remote config. */
	identity_?: IdentityConfig;
	flushMs_: number;
	/** init()-time partials, re-applied on top of remote config. */
	localAuto_: Partial<AutoTrackConfig>;
	localPrivacy_: Partial<PrivacyConfig>;
	q_: WireEvent[];
	/** Network waterfall rows awaiting flush (fed by the side chunk via XApi). */
	n_: WireNetRequest[];
	session_: WireSession | null;
	diag_: Diag;
}

export const st: SdkState = {
	key_: '',
	api_: '',
	env_: 'production',
	rel_: '',
	debug_: false,
	consent_: true,
	inited_: false,
	cfg_: false,
	auto_: { ...DEFAULT_AUTOTRACK },
	privacy_: { ...DEFAULT_PRIVACY },
	mappings_: [],
	formSteps_: [],
	zones_: [],
	bridges_: [],
	flushMs_: DEFAULT_FLUSH_INTERVAL_MS,
	localAuto_: {},
	localPrivacy_: {},
	q_: [],
	n_: [],
	session_: null,
	diag_: { initMs: 0, flushes: 0, sent: 0, dropped: 0, lastFlushMs: 0 },
};
